import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var FileCode = createReactComponent("FileCode", ["svg", defaultAttributes, [["path", {
  d: "M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4",
  key: "19r7vg"
}], ["path", {
  d: "M14 2v6h6",
  key: "1yykud"
}], ["path", {
  d: "M9 18l3-3-3-3",
  key: "446dnh"
}], ["path", {
  d: "M5 12l-3 3 3 3",
  key: "tm2zkr"
}]]]);
export default FileCode;